import { currentUser } from '../api/client'

// Símbolo de la moneda configurada de la empresa (EmpresaTipoMoneda — cuenta_bc.cs:1968);
// vacío → "$" (máscara GX). Fuente única para displays Y prefijos de inputs de dinero
// ([RGM] 2026-10-02, pedido Rafael: el símbolo orienta al digitar montos).
export const simboloMoneda = (): string =>
  (currentUser()?.moneda ?? '').trim() || '$'

// Formato de moneda — réplica de la máscara GX "$ Z,ZZZ,ZZZ,ZZ9.99"
// (arptcortecajadiario.cs:184): coma de miles y punto decimal de 2 dígitos.
export const fmtMoneda = (v: number | null | undefined): string => {
  if (v === null || v === undefined) return '—'
  const simbolo = simboloMoneda()
  const n = Number(v)
  if (Number.isNaN(n)) return '—'
  const signo = n < 0 ? '-' : ''
  const abs = Math.abs(n)
  const entero = Math.floor(abs).toString()
  const decimal = Math.round((abs - Math.floor(abs)) * 100).toString().padStart(2, '0')
  const conComas = entero.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return `${signo}${simbolo}${conComas}.${decimal}`
}
